
<div mat-dialog-content class="content">
    <mat-spinner></mat-spinner>
    <div class="text">Generating PDF</div>
</div>